import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles"

import { Avatar, Collapse, CssBaseline, FormControlLabel, Grid, Paper, Typography, Button, Link } from '@material-ui/core';
import CallIcon from '@material-ui/icons/Call';
import Carousel from 'react-material-ui-carousel';
import uuid from "uuid-random";
import logo from "../../assets/linet_logo_color_rgb.svg";
import Header from './header';
import Banner from './Banner';
import Credentials from './Credentials';

import sideBanner from "../../assets/PEGAUS_HEALTH_ELEMENTS-01.png";
import pageFooterLogo from "../../assets/PEGASUS_PORTAL_LOGOS-02.png";
import pageFooterLogoLeft from "../../assets/Logo_2_1.png";
import pageFooterLogoRight from "../../assets/Logo_2_2.png";
import shim from "../../assets/1x1.gif";

import Promotion from './Promotion';
import { api, Context } from '../../Portal';
import useRedirect from '../../hooks/useRedirect';
import ScrollableAnchor from 'react-scrollable-anchor'


const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: "100vh",
    },
    content: {
        width: "87.5%",
        marginLeft: "2.5%"
    },
    welcome: {
        padding: "1rem",
        borderTop: "4px solid #006db3",
    },
    loginRow: {
        
    },
    sideBanner: {
        backgroundSize: 'auto 100%',
				backgroundRepeat: 'no-repeat',
				
    },
    sideBannerContent: {
        display: 'flex',
        flexFlow: 'column',
        height: '100%',
        paddingLeft: '220px',
        verticalAlign: 'middle',
        justifyContent: 'center',
				color: '#e10600',
			fontSize: '30pt',
			alignContent: 'center',
    },
    sideBannerIntro: {
        fontSize: '40px',
        marginBottom: '5px',
				fontFamily: 'GT-America-Extended',
    },
    sideBannerHeading: {
        fontSize: '40px',
			marginBottom: '0px',
			textTransform: 'uppercase',
			fontFamily: 'GT-America-Extended',
    },
    sideBannerContentText: {
        fontSize: '20px',
    },
    sideBannerContentFineprint: {
        fontSize: '14px',
    },
    phone: {
        marginTop: "1rem",
    },
    callIcon: {
        margin: ".5rem"
    },
    infoTiles: {
        display: "flex",
        flex: 3,
        justifyContent: "space-between",
        "& > div:first-child": {
            marginRight: "10px",
        },
        "& > div + div": {
            marginRight: "6px",
            marginLeft: "6px",
        },
        "& > div:last-child": {
            marginRight: 0,
            marginLeft: "10px",
        },
    },
    middleBanner: {
        alignItems: 'center',
        padding: '50px 0',
    },
    bottomBanner: {
        alignItems: 'flex-start',
        padding: '50px 0',
			backgroundColor: '#fff',
			width: '100%',
				paddingLeft: '220px',
    },
    bannerHeading: {
        fontSize: '18pt',
        padding: '20px 0',
    },
    bannerContent: {
        width: '80%',
        fontSize: '14pt',
        textAlign: 'center',
        lineHeight: '1.5em',
			color: '#63666a',
			justifyContent: ''
    },
    bannerButton: {
        border: '1px solid #63666a',
        fontSize: '14pt',
        height: '50px',
        width: '300px',
    },
    pageFooter: {
        backgroundColor: '#F1F1F0',
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
			color: '#63666A',
    },
    pageFooterRows: {
        justifyContent: 'center',
        flexFlow: 'row nowrap',
			width: '100%',
			marginLeft: '220px',
    },
    pageFooterRow: {
        textAlign: 'left',
    },
    pageFooterRow1: {
        alignItems: 'center',
			justifyContent: 'space-between',
			width: '75%',
			borderBottom: '3px solid #D0D0CF'
    },
    pageFooterLogoLeft: {
        textAlign: 'right',
    },
    pageFooterLogoRight: {
        textAlign: 'left',
    },
		pageFooterLogo: {
		backgroundImage: `url(${logo})`,
		backgroundSize: 'auto 100%',
		backgroundRepeat: 'no-repeat',
			height: '100px',
			marginLeft: '-30px',
				width: '300px',
    },
    pageFooterPhoneNumber: {
        fontSize: '30pt',
    },
    pageFooterRow2: {
        alignItems: 'center',
        padding: '30px 0',
				justifyContent: 'flex-start',
				fontSize: '20px'
    },
    pageFooterRow3: {
        alignItems: 'center',
        padding: '30px 0',
        justifyContent: 'flex-start',
    },
    pageFooterAddress: {
        padding: '0 100px 0 0',
    },
    copyrightText: {
        fontSize: '11pt',
        marginLeft: '5px',
    },
    footerLoginLink: {
        color: '#ffffff',
        textDecoration: 'none',
	},
	greyHeader: {
		fontFamily: 'GT-America-Expanded',
		fontSize: '20pt',
		color: '#63666a',
		textTransform: 'uppercase',
		marginBottom: '20px',
	},
	redHeader: {
		fontFamily: 'GT-America-Expanded',
		fontSize: '20pt',
		color: '#e10600',
		textTransform: 'uppercase',
		marginBottom: '20px',
	},
	portalNameFooter: {
		marginBottom: '12px',
		clear: 'both',
	},
	maintenanceBanner: {
		color: '#e10600',
		fontFamily: 'GT-America-Expanded',
		fontSize: '10pt',
		border: '1px solid #e10600',
		padding: '5px',
		marginRight: '5px',
	},
}));

const url = "/views/v1/login";
const approvalUrl = "/api/v1/rentalorders/waiting-approval";

const Login = () => {
    const [state, dispatch] = useContext(Context);
    const [promotions, setPromotions] = useState([]);
    const [banners, setBanners] = useState([]);
    const [loggingIn, setLoggingIn] = useState(false);
    const { redirectToHome } = useRedirect();
    const { redirectToInvoiceApproval } = useRedirect();
    const { redirectToViewAuthorisations } = useRedirect();
	const classes = useStyles();
	const showPromotions = false;

    const Copyright = () => {
        return (
            <Typography className={classes.copyrightText} >
                &copy; { new Date().getFullYear()}  Linet
            </Typography>
        )
    }


    useEffect(() => {
        api.get(state.host + url)
            .then(({ data }) => {
                setPromotions(data.tiles);
                setBanners(data.banners);
                dispatch({ type: "LOGINPAGE-LOADED" });
            })
    }, []);

    useEffect(() => {
        if (state.authenticated) {
            if (!loggingIn) {
                setLoggingIn(true);
                getAuthorisationCount();
            }
        }
    }, [state.authenticated, redirectToHome, redirectToViewAuthorisations, redirectToInvoiceApproval])

    const getAuthorisationCount = () => {

        api.get(state.host + approvalUrl, state.credentials)
            .then(({ data }) => {
                dispatch({ type: "UPDATE-AUTHORISATION-COUNT", payload: { authorisationCount: data.headers.length } });
                if (state.user.menuItemPermissions.indexOf("Authorize Rental Transaction") !== -1 && data.headers.length > 0) {
                    redirectToViewAuthorisations();
                } else if (state.user.menuItemPermissions.indexOf("Create Rental Order") !== -1) {
                    redirectToHome();
                } else if (state.user.menuItemPermissions.indexOf("Authorize Rental Invoice") !== -1) {
                    redirectToInvoiceApproval();
                } else if (state.user.menuItemPermissions.indexOf("Authorize Rental Transaction") !== -1) {
                    redirectToViewAuthorisations();
                } else {
                    redirectToHome();
                }
            })
            .catch((error) => {
                if (state.user.menuItemPermissions.indexOf("Create Rental Order") !== -1) {
                    redirectToHome();
                } else if (state.user.menuItemPermissions.indexOf("Authorize Rental Invoice") !== -1) {
                    redirectToInvoiceApproval();
                } else if (state.user.menuItemPermissions.indexOf("Authorize Rental Transaction") !== -1) {
                    redirectToViewAuthorisations();
                }
            });
    }

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Header />
				{banners && banners.length > 0 &&
					<Collapse
						in={banners.length > 0}
						{...(banners.length > 0 ? { timeout: 750 } : {})}
						collapsedHeight={50}
					>
						<Carousel
							indicatorIconButtonProps={{
								style: {
									padding: '1px',
									color: 'transparent',
									border: '1px solid #FFFFFF',
									margin: '5px',
								}
							}}
							activeIndicatorIconButtonProps={{
								style: {
									backgroundColor: 'rgb(1, 104, 149, 0.3)'
								}
							}}
							indicatorContainerProps={{
								style: {
									marginBottom: '50px',
									textAlign: 'left',
									bottom: '-20px',
									position: 'absolute',
									left: '250px'
								}
							}}
							navButtonsAlwaysInvisible={true}
						>
							{banners.map((banner) => (
								<Banner item={banner} key={uuid()} />
							))}
						</Carousel>
					</Collapse>
				}
          <ScrollableAnchor id={'login'}>
            <Grid
                className={classes.content}
                container
                direction="row"
                justify="space-between"
                className={classes.loginRow}
            >
                <Grid
                    item
                    xs={7}
                    className={classes.sideBanner}
                >
                    <div className={classes.sideBannerContent}>
                        <div className={classes.sideBannerIntro}>Welcome to the</div>
								<div className={classes.sideBannerHeading}>LINET RENTAL PORTAL</div>
								<div className={classes.maintenanceBanner}>Please be advised our Rental online portal will be unavailable on 26th of September from 4:00PM to 5:00PM (AEST) due to scheduled maintenance.
									Our team will be available to assist with any urgent requests over the phone during this time.</div>
                    </div>
                            
                </Grid>
                <Grid
                    item
                    xs={4}

                >
                    <Credentials />
                </Grid>
                <Grid item xs={1} />
                </Grid>
				</ScrollableAnchor>
				{showPromotions && promotions && promotions.length > 0 &&
					<Grid
						container
						direction="column"
						justify="space-between"
						className={classes.middleBanner}
					>
						<Grid
							item
							xs={12}
							className={classes.infoTiles}
						>
							{promotions.map((promotion, index) => (<Promotion promotion={promotion} key={uuid()} />))}
						</Grid>
					</Grid>
				}
            <ScrollableAnchor id={'about'}>
            <Grid
                container
                direction="column"
                justify="space-between"
                spacing={5}
                className={classes.bottomBanner}
            >
                <Grid
                    item
                    xs={12}
                    className={classes.bannerContent}
                    
						>
							<div className={classes.greyHeader}>ABOUT US</div>

							<div className={classes.redHeader}>DESIGNED TO HELP YOU CARE</div>

							<p>With over 70 years of global expertise, LINET Group delivers innovative, clinically proven solutions that enhance patient outcomes and support caregivers through every stage of care.</p>

							<p>LINET Australia provides flexible rental options for a broad range of equipment, including pressure care mattresses, cushions, hospital beds, chairs, falls prevention systems, and bariatric care products tailored for Acute, Aged Care, and Community settings.</p>

							<p>Our end-to-end service covers delivery, professional installation, timely collection, meticulous decontamination, reliable maintenance, and responsive support, all designed to ensure safe, uninterrupted care.</p>

							<p>We proudly equip care teams across Australia with premium products and service excellence, helping create more effective and compassionate healthcare experiences.</p>

						</Grid>
					</Grid>
        </ScrollableAnchor>
				<ScrollableAnchor id={'contact'}>
					<Grid

						container
						direction="row"
						justify="space-between"
						className={classes.pageFooter}
					>
						<Grid
							container
							direction="row"
							justify="space-evenly"
							className={classes.pageFooterRows}
						>

                    <Grid
                        item
                        xs={12}
                        className={classes.pageFooterRow}
                    >	
                        <Grid
                            container
                            direction="row"
                            justify="space-evenly"
                            className={classes.pageFooterRow1}
                        >
                            <Grid
                                item
                                className={classes.pageFooterLogoRight}
													>
																<img className={classes.pageFooterLogo}  src={shim} />
                            </Grid>
                            <Grid
                                item
                                className={classes.pageFooterPhoneNumber}
                            >
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justify="space-evenly"
                            className={classes.pageFooterRow2}
                        >
                            <Grid
                                item
                                className={classes.pageFooterAddress}
                            >
										<div className={classes.portalNameFooter }>LINET RENTAL PORTAL</div>
																LINET Australia<br />
                                1/30 Heathcote Road, Moorebank, NSW 2170<br />
                                Telephone 1300 303 603
                            </Grid>
                        </Grid>
                       
                    </Grid>
                </Grid>
                </Grid>
            </ScrollableAnchor>
        </div>
    )
}

export default Login;
